import { Skeleton } from "@douyinfe/semi-ui";
import styles from "./PageSkeleton.module.scss";

export default function PageSkeleton() {
  const placeholderLeft = (
    <div className={`${styles.container} ${styles.left}`}>
      <Skeleton.Avatar style={{ marginRight: 12, width: 40, height: 40 }} />
      <div className={styles.content}>
        <Skeleton.Title style={{ width: 120 }} />
        <Skeleton.Title style={{ width: 240 }} />
      </div>
    </div>
  );

  const placeholderRight = (
    <div className={`${styles.container} ${styles.right}`}>
      <div className={styles.content}>
        <Skeleton.Title style={{ width: 120 }} />
        <Skeleton.Title style={{ width: 240 }} />
      </div>
    </div>
  );

  return (
    <div className={styles.pageSkeleton}>
      <div className={styles.chatHeader}>
        <Skeleton.Paragraph rows={1} className={styles.header} />
      </div>
      <div className={styles.chatBody}>
        <Skeleton placeholder={placeholderLeft}></Skeleton>
        <Skeleton placeholder={placeholderRight}></Skeleton>
        <Skeleton placeholder={placeholderLeft}></Skeleton>
        <Skeleton placeholder={placeholderRight}></Skeleton>
        <Skeleton placeholder={placeholderRight}></Skeleton>
        <Skeleton placeholder={placeholderRight}></Skeleton>
        <Skeleton placeholder={placeholderLeft}></Skeleton>
      </div>
      <div className={styles.inputChat}>
        <Skeleton.Paragraph rows={1} className={styles.inputBox} />
        <Skeleton.Button className={styles.sendButton} />
      </div>
    </div>
  );
}
